import { FlightProps } from '@msc-b2c/interfaces/types';
import { Accordion, Text } from '@msc-b2c/shared-components';
import { useState } from 'react';
import styles from '../stateroomdetails.module.scss';
import PassengersInfo from './PassengersInfo';

const Flight: React.FC<FlightProps> = ({
  flightId,
  passengers,
  flightStatusLabel,
  flightClassLabel,
  airlineLabel,
  flightDetailsLabel,
  flightsSectionIcon,
  flightsSectionTitle,
  flightStatusValue,
  flightSegments,
  viewDetailsFlightLabel,
  openViewDetailsFlightIcon,
  closeViewDetailsFlightIcon,
}) => {
  const [openId, setOpenId] = useState<string | null>(null);
  return (
    <Accordion
      question={flightsSectionTitle}
      answer=""
      isOpen={openId === flightId}
      autoClose={false}
      questionIcon={flightsSectionIcon}
      openingIcon={openViewDetailsFlightIcon}
      closingIcon={closeViewDetailsFlightIcon}
      multi={true}
      onToggle={() => setOpenId((prev) => (prev === flightId ? null : flightId))}
      viewDetailsLabel={viewDetailsFlightLabel}
      styleOption={styles.includedWithBookingAccordion}
    >
      <>
        {passengers?.length > 0 &&
          passengers.map(
            (p) =>
              p.passengerLabel && (
                <div
                  className={styles.passengerDetailsContainer}
                  key={p.id}
                >
                  <div className={styles.passengerDetailsContent}>
                    <PassengersInfo
                      passengerLabel={p.passengerLabel}
                      passengerName={`${p.name} ${p.surname}`}
                    />
                  </div>
                </div>
              )
          )}

        {flightStatusValue && (
          <div className={styles.flightInfoSection}>
            <Text
              text={flightStatusLabel}
              styleOption={styles.flightDetailsLabel}
            />
            <Text text={flightStatusValue} />
          </div>
        )}

        {flightSegments?.length > 0 &&
          flightSegments.map((segment) => (
            <>
              {segment.airline && (
                <div className={styles.flightInfoSection}>
                  <Text
                    text={airlineLabel}
                    styleOption={styles.flightDetailsLabel}
                  />
                  <Text text={segment.airline} />
                </div>
              )}
              {segment.class && (
                <div className={styles.flightInfoSection}>
                  <Text
                    text={flightClassLabel}
                    styleOption={styles.flightDetailsLabel}
                  />
                  <Text text={segment.class} />
                </div>
              )}
              {segment.details && (
                <div className={`${styles.flightDetailsSection} ${styles.flightInfoSection}`}>
                  <Text
                    text={flightDetailsLabel}
                    styleOption={styles.flightDetailsLabel}
                  />
                  <Text text={segment.details} />
                </div>
              )}
            </>
          ))}
      </>
    </Accordion>
  );
};

export default Flight;
